import type { CSSProperties } from "react";
import { loaderSpec, type LoaderSize } from "../specs/display";
import { mergeVars } from "../specs/types";

export interface LoaderProps {
  size?: LoaderSize;
  label?: string;
}

export function Loader({ size = loaderSpec.defaults.size, label }: LoaderProps) {
  return (
    <span
      className="ui-loader"
      role="status"
      aria-label={label ?? "loading"}
      style={mergeVars(loaderSpec.base, loaderSpec.sizes[size]) as CSSProperties}
    />
  );
}
